import { handleError } from "../../../util/errors";
import apiBase from "../../api";

class AppVersionsService {
  // Get all versions
  fetchVersions = async (includeInactive = false) => {
    try {
      const url = `/app-versions${includeInactive ? '?includeInactive=true' : ''}`;
      const response = await apiBase.get(url);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching app versions");
    }
  };

  // Get single version with device count
  fetchVersion = async (versionId) => {
    try {
      const response = await apiBase.get(`/app-versions/${versionId}`);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching app version");
    }
  };

  // Get latest version
  fetchLatestVersion = async () => {
    try {
      const response = await apiBase.get("/app-versions/latest");
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching latest version");
    }
  };

  // Create version
  createVersion = async (data) => {
    try {
      const response = await apiBase.post("/app-versions", data);
      if (response.status !== 201 && response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error creating app version");
    }
  };

  // Update version
  updateVersion = async (versionId, data) => {
    try {
      const response = await apiBase.put(`/app-versions/${versionId}`, data);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error updating app version");
    }
  };

  // Delete version
  deleteVersion = async (versionId) => {
    try {
      const response = await apiBase.delete(`/app-versions/${versionId}`);
      if (response.status !== 200 && response.status !== 204) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error deleting app version");
    }
  };

  // Set as latest
  setAsLatest = async (versionId) => {
    try {
      const response = await apiBase.patch(`/app-versions/${versionId}/set-latest`);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error setting version as latest");
    }
  };

  // Get version stats
  fetchStats = async () => {
    try {
      const response = await apiBase.get("/app-versions/stats");
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching version stats");
    }
  };

  // Get devices on specific version
  fetchDevicesOnVersion = async (version, page = 1, perPage = 20) => {
    try {
      const response = await apiBase.get(`/app-versions/devices/${version}?page=${page}&perPage=${perPage}`);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching devices on version");
    }
  };
}

export default new AppVersionsService();

